import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ErrorIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 13, height: 13, viewBox: "0 0 13 13" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.5 13a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zm0-.867A5.633 5.633 0 1 0 6.5.867a5.633 5.633 0 0 0 0 11.266zm-.3-3.132h.599c.11 0 .2.09.2.2V9.8a.2.2 0 0 1-.2.2H6.2a.2.2 0 0 1-.2-.2v-.599c0-.11.09-.2.2-.2zM6.2 3h.6c.11 0 .2.09.2.2v4.6a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V3.2c0-.11.09-.2.2-.2z"
  }
));

export { ErrorIcon as default };
//# sourceMappingURL=ErrorIcon.js.map
